export const stripLinesReportInitialValue = {
  cdTipoRelatorioLinhas: 1,
  localidades: [],
  subSistemas: [],
  linhas: [],
  empresas: [],
  tiposVeiculo: [],
  tiposServico: [],
  dtCadastro: { dtInicio: '', dtFim: "" },
  dtVencimento: { dtInicio: '', dtFim: "" },
  situacaoLinha: 1,
  outorgas: [],
};

export const slicLinesReportInitialValue = {
  cdTipoRelatorioLinhas: 4,
  polos: [],
  localidades: [],
  tiposVeiculo: [],
  nuEdital: '',
  linhas: [],
  permissionarios: [],
};
